import ArticleTemplate from '@/pages/article/components/ArticleTemplate';

export default function ArticleCoupon() {
  return <ArticleTemplate slug="sugargoo-coupon-guide" />;
}